// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3zVph","row":"styles_row__1rxfU"};